import React from 'react';
import PropTypes from 'prop-types';

import Icon from '../icon';
import Link from '../link';
import RichText from '../rich-text';

const MyPageSection = ({
  children,
  headingLevel,
  ingress,
  label,
  link,
  links,
  title
}) => {
  const Title = 'h' + headingLevel;

  return (
    <div className="my-page-section">
      <div className="my-page-section-header">
        <Title>{title}</Title>
        {ingress && (
          <RichText
            className="my-page-section-ingress"
            theme={RichText.themes.centered}
            {...ingress}
          />
        )}

        {label && <p>{label}</p>}
        {link && (
          <Link theme={Link.themes.skew} {...link}>
            <Icon className="my-orders-link-icon" name="small-arrow-right" />
          </Link>
        )}

        {links.length > 0 &&
          links.map(link => (
            <Link key={link.url} theme={Link.themes.skew} {...link}>
              <Icon className="my-orders-link-icon" name="small-arrow-right" />
            </Link>
          ))}
      </div>
      {children}
    </div>
  );
};

MyPageSection.propTypes = {
  children: PropTypes.node,
  headingLevel: PropTypes.number,
  ingress: PropTypes.exact(RichText.propTypes),
  label: PropTypes.string,
  link: PropTypes.exact(Link.propTypes),
  links: PropTypes.arrayOf(PropTypes.exact(Link.propTypes)),
  title: PropTypes.string
};

MyPageSection.propTypesMeta = {
  headingLevel: 'exclude'
};

MyPageSection.defaultProps = {
  headingLevel: 2,
  links: []
};

export default MyPageSection;
